<script setup lang="ts">
defineOptions({
	name: 'IconEntertainment',
})

interface Props {
	class?: string
	classIcon?: string
}

const props = withDefaults(defineProps<Props>(), {
	class: 'text-neutral-50',
	classIcon: 'w-8 h-8',
})
</script>

<template>
	<svg
		:class="[props.class, props.classIcon]"
		viewBox="0 0 31 31"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M22.2557 9.16125L19.3913 12.027L17.6703 10.3076"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M20.59 17.1521C24.291 16.8134 27.0532 13.5953 26.8269 9.88571C26.6007 6.17612 23.4679 3.31756 19.7531 3.43113C16.0384 3.5447 13.0861 6.5893 13.0869 10.3058C13.0869 10.5169 13.0997 10.7248 13.1184 10.931"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<rect
			x="4.33319"
			y="19.4502"
			width="3.75156"
			height="7.73757"
			rx="0.639614"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M8.20198 25.5277L9.72239 26.7834C10.0388 27.0448 10.4364 27.1878 10.8468 27.1878H15.9607C16.7982 27.1878 17.5342 26.6326 17.7643 25.8273L18.6317 22.7916C18.8136 22.1549 18.6861 21.4697 18.2874 20.941C17.8886 20.4124 17.2648 20.1016 16.6027 20.1016H14.3374"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M14.3374 20.1015V18.0209C14.3374 17.0881 13.7175 16.2688 12.8198 16.0152C11.922 15.7616 10.9651 16.1354 10.477 16.9304L8.08475 20.8266"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
